import { Cell, Grid, HeadingSection, HFlow, Icon, Text } from 'bold-ui'

interface CompartilhaProntuarioSectionProps {
  statusCompartilhaProntuario: boolean
}

export const CompartilhaProntuarioSection = (props: CompartilhaProntuarioSectionProps) => {
  const { statusCompartilhaProntuario } = props

  return (
    <HeadingSection level={2} title='Compartilhamento de dados do histórico clínico'>
      <Grid wrap>
        <Cell size={6}>
          <Text>
            Por padrão, o histórico clínico do cidadão é visível por todas as unidades de saúde de uma mesma instalação
            do Prontuário Eletrônico e-SUS APS, para agilizar o atendimento em toda a rede. Se o cidadão não concorda
            com essa condição, marque a opção abaixo para desativar o compartilhamento de atendimentos no prontuário.
          </Text>
        </Cell>
        <Cell size={6} />
        <Cell size={4}>
          <HFlow alignItems='center' hSpacing={0.5}>
            {statusCompartilhaProntuario ? (
              <>
                <Icon icon='checkCircleOutline' size={1} fill='success' />
                <Text color='success'>Compartilhamento de histórico clínico ativo</Text>
              </>
            ) : (
              <>
                <Icon icon='banOutline' size={1} fill='danger' />
                <Text color='danger'>Compartilhamento de histórico clínico desativado</Text>
              </>
            )}
          </HFlow>
        </Cell>
      </Grid>
    </HeadingSection>
  )
}
